module.exports = ".innovation {\n  margin: 24px; }\n  .innovation .innovation-description {\n    white-space: pre-wrap;\n    opacity: 0.5; }\n"